import { jsx as _jsx } from "react/jsx-runtime";
var VolumeOff = function VolumeOff(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5 10.6714V5.8984L10.668 7.8394L9.229 6.4014L13.935 3.1744C14.24 2.9644 14.637 2.9414 14.966 3.1154C15.294 3.2884 15.5 3.6284 15.5 4.0004V12.6714L13.5 10.6714ZM4.707 3.293C4.316 2.902 3.684 2.902 3.293 3.293C2.902 3.684 2.902 4.316 3.293 4.707L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293L4.707 3.293ZM16.9106 14.082L18.3486 15.521C19.9066 13.483 19.8886 10.374 18.2796 8.373C17.9326 7.943 17.3036 7.876 16.8726 8.221C16.4426 8.567 16.3746 9.196 16.7206 9.627C17.6836 10.823 17.7386 12.778 16.9106 14.082ZM19.222 16.394C20.37 15.121 21 13.599 21 12C21 10.036 20.063 8.18 18.362 6.771C17.937 6.418 17.877 5.787 18.23 5.362C18.582 4.937 19.212 4.878 19.638 5.229C21.806 7.025 23 9.431 23 12C23 14.137 22.163 16.155 20.637 17.809L19.222 16.394ZM13.5 18.1016L8.399 14.6036C8.232 14.4906 8.035 14.4286 7.833 14.4286H3.5V9.5716H6.743L4.743 7.5716H2.5C1.948 7.5716 1.5 8.0186 1.5 8.5716V15.4286C1.5 15.9816 1.948 16.4286 2.5 16.4286H7.523L13.935 20.8256C14.104 20.9416 14.302 20.9996 14.5 20.9996C14.66 20.9996 14.82 20.9616 14.966 20.8846C15.294 20.7116 15.5 20.3716 15.5 19.9996V18.3286L13.5 16.3286V18.1016Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default VolumeOff;